/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import DisplayedWordVo from './DisplayedWordVo';
import IseTextVo from './IseTextVo';
import RefWordVo from './RefWordVo';




  /**
   * The ReadbackDrillVo model module.
   * @module drill/model/ReadbackDrillVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>ReadbackDrillVo</code>.
   * @alias module:drill/model/ReadbackDrillVo
   * @class
   * @param required {Boolean} 必做
   * @param subType {Integer} 501看文字朗读，502听录音复诵，503口译
   * @param markedText {String} 标注文本
   * @param displayText {Array.<module:drill/model/DisplayedWordVo>} 
   * @param refText {Array.<module:drill/model/RefWordVo>} 
   */
  var exports = function(required, subType, markedText, displayText, refText) {
    var _this = this;


    _this['required'] = required;
    _this['subType'] = subType;



    _this['markedText'] = markedText;
    _this['displayText'] = displayText;
    _this['refText'] = refText;




  };

  /**
   * Constructs a <code>ReadbackDrillVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/ReadbackDrillVo} obj Optional instance to populate.
   * @return {module:drill/model/ReadbackDrillVo} The populated <code>ReadbackDrillVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'required')) {
        obj['required'] = ApiClient.convertToType(data['required'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'subType')) {
        obj['subType'] = ApiClient.convertToType(data['subType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'text')) {
        obj['text'] = ApiClient.convertToType(data['text'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'explanation')) {
        obj['explanation'] = ApiClient.convertToType(data['explanation'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'tips')) {
        obj['tips'] = ApiClient.convertToType(data['tips'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'markedText')) {
        obj['markedText'] = ApiClient.convertToType(data['markedText'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'displayText')) {
        obj['displayText'] = ApiClient.convertToType(data['displayText'], [DisplayedWordVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'refText')) {
        obj['refText'] = ApiClient.convertToType(data['refText'], [RefWordVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'iseText')) {
        obj['iseText'] = IseTextVo.constructFromObject(data['iseText']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'translatedText')) {
        obj['translatedText'] = ApiClient.convertToType(data['translatedText'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'audioUri')) {
        obj['audioUri'] = ApiClient.convertToType(data['audioUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'imageUri')) {
        obj['imageUri'] = ApiClient.convertToType(data['imageUri'], 'String');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 必做
   * @member {Boolean} required
   */
  exports.prototype['required'] = undefined;
  /**
   * 501看文字朗读，502听录音复诵，503口译
   * @member {Integer} subType
   */
  exports.prototype['subType'] = undefined;
  /**
   * 文本 不用传
   * @member {String} text
   */
  exports.prototype['text'] = undefined;
  /**
   * 解析
   * @member {String} explanation
   */
  exports.prototype['explanation'] = undefined;
  /**
   * 提示
   * @member {String} tips
   */
  exports.prototype['tips'] = undefined;
  /**
   * 标注文本
   * @member {String} markedText
   */
  exports.prototype['markedText'] = undefined;
  /**
   * @member {Array.<module:drill/model/DisplayedWordVo>} displayText
   */
  exports.prototype['displayText'] = undefined;
  /**
   * @member {Array.<module:drill/model/RefWordVo>} refText
   */
  exports.prototype['refText'] = undefined;
  /**
   * 用于讯飞打分的文本
   * @member {module:drill/model/IseTextVo} iseText
   */
  exports.prototype['iseText'] = undefined;
  /**
   * 翻译
   * @member {String} translatedText
   */
  exports.prototype['translatedText'] = undefined;
  /**
   * 音频uri
   * @member {String} audioUri
   */
  exports.prototype['audioUri'] = undefined;
  /**
   * 图片uri
   * @member {String} imageUri
   */
  exports.prototype['imageUri'] = undefined;



  export default exports;
;


